<div class="modal-with-link" *ngIf="label && copy">
  {{ preLabel }}<vm-link (click)="openModal($event)" [type]="'standalone'" [href]="'#'">{{ label }}</vm-link
  >{{ postLabel }}
  <vm-modal
    *ngIf="isModalOpen"
    [modalType]="modalType"
    [title]="title || label"
    [hideHeader]="false"
    (closeButtonClick)="isModalOpen = false">
    <markdown ngPreserveWhitespaces>
      {{ copy }}
    </markdown>
  </vm-modal>
</div>
